import axios from 'axios';

function viewerApi(data, _callback) {
  switch (data.type) {
    case 'GET_CONTENTS': {
      let CONTENT;
      // GET del CONTEÚDO
      axios
        .get(`cms/contents/${data.content_guid}`)
        .then((res) => {
          CONTENT = res.data.data;
          CONTENT.type = CONTENT['mime-type'] == null || CONTENT['mime-type'] == '' ? CONTENT.type_guid : CONTENT['mime-type'];
          CONTENT.comments = [];
          CONTENT.playlists = [];
          CONTENT.playlist_groups = [];
          CONTENT.reviews = [];
          CONTENT.courses = [];
          CONTENT.questions = [];
          CONTENT.usefull = 0;
          CONTENT.difficult = 0;
          CONTENT.annotations = [];

          if (CONTENT.type_guid === 'CTTY_20') {
            if (!data.studentGuid) {
              _callback(CONTENT);
            } else {
              const params_post = {
                content_guid: data.content_guid,
                student_guid: data.studentGuid,
              };

              axios
                .post(`lrs/xapi-state`, params_post)
                .then((result_xapi_state) => {
                  if (result_xapi_state && result_xapi_state.data && result_xapi_state.data.data && result_xapi_state.data.data.ghostUser) {
                    CONTENT.ghostUser = result_xapi_state.data.data.ghostUser;
                  } else {
                    CONTENT.ghostUser = null;
                  }

                  _callback(CONTENT);
                })
                .catch((error) => {
                  console.log(error);
                  _callback(CONTENT);
                });
            }
          } else {
            axios
              .get(`cms/contents/${data.content_guid}/annotations?includeWithoutParent=true`)
              .then((result_annotations) => {
                CONTENT.annotations = result_annotations.data.data;
                _callback(CONTENT);
              })
              .catch((error) => {
                console.log(error);
                _callback(CONTENT);
              });
          }
        })
        .catch((error) => {
          console.log(error);
          _callback(error);
        });
      break;
    }
    case 'GET_PUBLIC_CONTENTS': {
      let CONTENT;
      // GET del CONTEÚDO
      axios
        .get(`front/public-viewer/${data.content_guid}`)
        .then((res) => {
          CONTENT = res.data.data;
          CONTENT.type = CONTENT['mime-type'] == null || CONTENT['mime-type'] == '' ? CONTENT.type_guid : CONTENT['mime-type'];
          CONTENT.comments = [];
          CONTENT.playlists = [];
          CONTENT.playlist_groups = [];
          CONTENT.reviews = [];
          CONTENT.courses = [];
          CONTENT.questions = [];
          CONTENT.usefull = 0;
          CONTENT.difficult = 0;
          CONTENT.annotations = [];

          _callback(CONTENT);
        })
        .catch((error) => {
          console.log(error);
          _callback(error);
        });
      break;
    }
    case 'GET_COMMON_ELEMENTS': {
      const CONTENT = {};
      const params_ = { content_guid: data.content_guid };
      CONTENT.comments = [];
      CONTENT.playlists = [];
      CONTENT.playlist_groups = [];
      CONTENT.reviews = [];
      CONTENT.courses = [];
      CONTENT.questions = [];
      CONTENT.usefull = 0;
      CONTENT.difficult = 0;

      // GET de ELEMENTOS COMUNES
      axios
        .get(`cms/contents/${params_.content_guid}/common-elements`, { params_ })
        .then((common_elements) => {
          CONTENT.comments = common_elements.data.data.comments;
          CONTENT.playlists = common_elements.data.data.playlists;
          CONTENT.reviews = common_elements.data.data.reviews;

          if (CONTENT.reviews.length > 0) {
            CONTENT.usefull = common_elements.data.data.reviews[0].usefull_rating;
            CONTENT.difficult = common_elements.data.data.reviews[0].difficult_rating;
          }

          // GET de PLAYLIST GROUPS
          axios
            .get(`cms/contents/playlist-groups`)
            .then((playlist_groups) => {
              CONTENT.playlist_groups = playlist_groups.data.data;

              // GET de COURSES
              axios
                .get(`front/courses`)
                .then((_courses) => {
                  try {
                    CONTENT.courses = _courses.data.data || [];
                  } catch (e) {
                    CONTENT.courses = [];
                  }

                  _callback(CONTENT);
                })
                .catch((error) => {
                  console.log(error);
                  _callback(error);
                });
            })
            .catch((error) => {
              console.log(error);
              _callback(error);
            });
        })
        .catch((error) => {
          console.log(error);
          _callback(error);
        });
      break;
    }
    case 'GET_ANNOTATIONS_PAGES':
      axios
        .get(`cms/contents/${data.contentGuid}/annotations`, { params: { parent: data.parent } })
        .then((annots) => {
          _callback(annots);
        })
        .catch((error) => {
          console.log(error);
          _callback(error);
        });
      break;
    case 'POST_ANNOTATION':
      const params_post_annotation = {
        guid: data.params.guid,
        annotation: data.params.annotation,
        parent_guid: data.params.parent,
      };

      axios
        .post(`cms/contents/${data.params.content_guid}/annotations`, params_post_annotation)
        .then((result_annotation) => {
          _callback(result_annotation);
        })
        .catch((error) => {
          console.log(error);
          _callback(error);
        });
      break;
    case 'PUT_ANNOTATION':
      const params_put_annotation = {
        guid: data.params.guid,
        annotation: data.params.annotation,
        parent_guid: data.params.parent,
      };

      axios
        .put(`cms/contents/${data.params.content_guid}/annotations/${data.params.guid}`, params_put_annotation)
        .then((result_annotation) => {
          _callback(result_annotation);
        })
        .catch((error) => {
          console.log(error);
          _callback(error);
        });
      break;
    case 'DELETE_ANNOTATION':
      if (typeof data.params.guid === 'string') {
        data.params.guid = [String(data.params.guid)];
      }

      const params_delete_annotation = { data: { guid: data.params.guid } };

      axios
        .delete(`cms/contents/${data.params.content_guid}/annotations`, params_delete_annotation)
        .then((result_annotation) => {
          _callback(result_annotation);
        })
        .catch((error) => {
          console.log(error);
          _callback(error);
        });
      break;
    case 'INIT_SESION_CONSUMPTION':
      axios
        .post('consumptions', data.params)
        .then((res) => {
          _callback(res.data.data);
        })
        .catch((error) => {
          console.log(error);
          _callback(error);
        });
      break;
    case 'UPDATE_CONSUMPTION':
      // Consulta a servicio para CERRAR la SESIÓN DEL CONSUMO
      axios
        .post('consumptions/' + data.params.consumption_guid + '/progress', data.params)
        .then((res) => {
          _callback(res.data.data);
        })
        .catch((error) => {
          console.log(error);
          _callback(error);
        });
      break;
    case 'CLOSE_SESION_CONSUMPTION':
      const params = {
        consumption_guid: data.consumption_guid,
        guid: data.session_guid,
        ended_at: Date.now(),
      };

      // Consulta a servicio para CERRAR la SESIÓN DEL CONSUMO
      axios
        .put('consumptions/' + data.consumption_guid + '/sessions/' + data.session_guid, params)
        .then((res) => {
          _callback(res);
        })
        .catch((error) => {
          console.log(error);
          _callback(error);
        });
      break;
    case 'SEND_EVALUATE_CONTENT':
      const params2 = {
        usefull_rating: parseInt(data.params2.usefull_rating),
        difficult_rating: parseInt(data.params2.difficult_rating),
        content_guid: data.params2.content_guid,
      };

      axios
        .post('/cms/contents/' + params2.content_guid + '/reviews', params2)
        .then((res) => {
          _callback(res);
        })
        .catch((error) => {
          console.log(error);
          _callback(error);
        });
      break;
    case 'SEND_REPORT_CONTENT':
      const params3 = {
        type: data.params3.type,
        comment: data.params3.comment,
        content_guid: data.params3.content_guid,
      };

      axios
        .post('/cms/contents/' + params3.content_guid + '/reports', params3)
        .then((res) => {
          _callback(res);
        })
        .catch((error) => {
          console.log(error);
          _callback(error);
        });
      break;
    case 'SEND_REPORT_CONTENT_ERROR':
      const params_report = {
        type: data.params.type,
        comment: data.params.comment,
        content_guid: data.params.content_guid,
      };

      axios
        .post('cms/contents/' + data.params.content_guid + '/reports', params_report)
        .then((res) => {
          _callback(res);
        })
        .catch((error) => {
          console.log(error);
          _callback(error);
        });

      break;

    case 'GET_REPORT_CONTENT_ERROR':
      axios
        .get(`/cms/contents/reports`, { params: { content: Array(String(data.params.content_guid)) } })
        .then((res) => {
          _callback(res);
        })
        .catch((error) => {
          console.log(error);
          _callback(error);
        });

      break;
    case 'POST_PLAYLIST_GROUP':
      const params4 = {
        title: data.params4.title,
        thumbnail: data.params4.thumbnail,
        description: data.params4.description,
      };

      axios
        .post('cms/contents/playlist-groups', params4)
        .then((res) => {
          _callback(res);
        })
        .catch((error) => {
          console.log(error);
          _callback(error);
        });
      break;
    case 'DELETE_PLAYLIST_GROUP':
      const params5 = {
        guid: data.params5.guid,
      };

      axios
        .delete('cms/contents/playlist-groups/' + params5.guid, params5)
        .then((res) => {
          _callback(res);
        })
        .catch((error) => {
          console.log(error);
          _callback(error);
        });
      break;
    case 'POST_CONTENT_IN_PLAYLIST':
      const params6 = {
        content_guid: data.params6.content_guid,
        show_at: data.params6.show_at,
        group_guid: data.params6.group_guid,
      };

      axios
        .post('cms/contents/' + params6.content_guid + '/playlists', params6)
        .then((res) => {
          _callback(res);
        })
        .catch((error) => {
          console.log(error);
          _callback(error);
        });
      break;
    case 'PUT_CONTENT_IN_PLAYLIST':
      const params7 = {
        content_guid: data.params7.content_guid,
        show_at: data.params7.show_at,
        group_guid: data.params7.group_guid,
        guid: data.params7.guid,
      };

      axios
        .put('cms/contents/' + params7.content_guid + '/playlists/' + params7.guid, params7)
        .then((res) => {
          _callback(res);
        })
        .catch((error) => {
          console.log(error);
          _callback(error);
        });
      break;
    case 'DELETE_CONTENT_OF_PLAYLIST':
      const params8 = {
        content_guid: data.params8.content_guid,
        guid: data.params8.guid,
      };

      axios
        .delete('cms/contents/' + params8.content_guid + '/playlists/' + params8.guid, params8)
        .then((res) => {
          _callback(res);
        })
        .catch((error) => {
          console.log(error);
          _callback(error);
        });
      break;
    case 'POST_COURSE':
      const params9 = {
        name: data.params9.name,
      };

      axios
        .post('lms/courses', params9)
        .then((res) => {
          _callback(res);
        })
        .catch((error) => {
          console.log(error);
          _callback(error);
        });
      break;
    case 'POST_CONTENT_COMMENT': {
      let params_all = {};

      if (data.params.shared_type == 'courses') {
        params_all = {
          shared_type: data.params.shared_type,
          comment: data.params.comment,
          content_guid: data.params.content_guid,
          show_at: data.params.show_at,
          shared_courses: data.params.shared_courses,
        };
      } else {
        params_all = {
          shared_type: data.params.shared_type,
          comment: data.params.comment,
          content_guid: data.params.content_guid,
          show_at: data.params.show_at,
        };
      }
      if (data.params.parent_guid != null) {
        params_all.parent_guid = data.params.parent_guid;
      }

      axios
        .post('/cms/contents/' + params_all.content_guid + '/comments', params_all)
        .then((res) => {
          _callback(res);
        })
        .catch((error) => {
          console.log(error);
          _callback(error);
        });
      break;
    }
    case 'PUT_CONTENT_COMMENT': {
      let params_all = {};

      if (data.params.shared_type == 'courses') {
        params_all = {
          guid: data.params.guid,
          shared_type: data.params.shared_type,
          comment: data.params.comment,
          content_guid: data.params.content_guid,
          show_at: data.params.show_at,
          shared_courses: data.params.shared_courses,
        };
      } else {
        params_all = {
          guid: data.params.guid,
          shared_type: data.params.shared_type,
          comment: data.params.comment,
          content_guid: data.params.content_guid,
          show_at: data.params.show_at,
        };
      }
      if (data.params.parent_guid != null) {
        params_all.parent_guid = data.params.parent_guid;
      }

      axios
        .put('/cms/contents/' + params_all.content_guid + '/comments/' + params_all.guid, params_all)
        .then((res) => {
          _callback(res);
        })
        .catch((error) => {
          console.log(error);
          _callback(error);
        });
      break;
    }
    case 'DELETE_CONTENT_COMMENT':
      const params10 = {
        guid: data.params10.guid,
        content_guid: data.params10.content_guid,
      };

      axios
        .delete('/cms/contents/' + params10.content_guid + '/comments/' + params10.guid, params10)
        .then((res) => {
          _callback(res);
        })
        .catch((error) => {
          console.log(error);
          _callback(error);
        });
      break;
    case 'POST_COURSE_OF_COMMENT':
      const params11 = {
        // content_guid: _data.content_guid,
        // comment_guid: _data.comment_guid,
        course: data.params11.course_guid,
      };

      axios
        .post('/cms/contents/' + data.params11.content_guid + '/comments/' + data.params11.comment_guid + '/courses', params11)
        .then((res) => {
          _callback(res);
        })
        .catch((error) => {
          console.log(error);
          _callback(error);
        });
      break;
    case 'DELETE_COURSE_OF_COMMENT':
      axios
        .delete('/cms/contents/' + data.params.content_guid + '/comments/' + data.params.comment_guid + '/courses/' + data.params.course_guid)
        .then((res) => {
          _callback(res);
        })
        .catch((error) => {
          console.log(error);
          _callback(error);
        });
      break;
    case 'GET_METASCRAPER':
      axios
        .get(`cms/metascraper?url=` + data.url)
        .then((_result) => {
          if (_result.error) {
            _callback(_result);
          } else {
            _callback(_result.data.data);
          }
        })
        .catch((error) => {
          console.log(error);
          _callback(error);
        });
      break;
    case 'POST_EXERCISE_TRACE':
      console.log('POST_EXERCISE_TRACE');
      console.log(data.params);
      axios
        .post('/lrs/records', data.params)
        .then((res) => {
          _callback(res);
        })
        .catch((error) => {
          console.log(error);
          _callback(error);
        });

      break;
    case 'GET_EXERCISE_TRACE':
      console.log('GET_EXERCISE_TRACE');
      console.log(data.params);

      axios
        .get(`/lrs/records`, { params: data.params })
        .then((_result) => {
          _callback(_result.data);
        })
        .catch((error) => {
          console.log(error);
          _callback(error);
        });
      break;
    case 'GET_USERS_ACCESS_TOKEN':
      axios
        .get(`users/access-token`)
        .then((_result) => {
          _callback(_result.data);
        })
        .catch((error) => {
          console.log(error);
          _callback(error);
        });

      break;
    case 'GET_LANGS':
      axios
        .get(`langs/scopes`, { params: data.params })
        .then((_result) => {
          _callback(_result.data);
        })
        .catch((error) => {
          console.log(error);
          _callback(error);
        });
      break;
    case 'POST_LANGS':
      console.log(data.params);
      axios
        .post('langs/scopes', data.params)
        .then((res) => {
          _callback(res);
        })
        .catch((error) => {
          console.log(error);
          _callback(error);
        });
      break;
    case 'PUT_LANGS':
      const params_lang = { json: data.params.json };
      axios
        .put('langs/scopes/' + data.params.scopeId, params_lang)
        .then((res) => {
          _callback(res);
        })
        .catch((error) => {
          console.log(error);
          _callback(error);
        });
      break;
    case 'GET_LANG': {
      const _lang = {};
      setTimeout(function () {
        _callback(_lang);
      }, 100);
      break;
    }
  }
}

export async function getAllAnnotations(contentGuid) {
  return await axios.get(`cms/contents/${contentGuid}/annotations`);
}

export async function deleteAnnotationOne(contentGuid, annotationGuid) {
  return await axios.delete(`cms/contents/${contentGuid}/annotations`, {
    data: {
      guid: [annotationGuid],
    },
  });
}

export default viewerApi;
